import type { Chassis, Director, Driver, Team } from "../types";
import { computeSynergy } from "./synergy";

/** Everything needed to build a Team; synergy and season points are derived. */
export interface TeamInit {
  readonly name: string;
  readonly d1: Driver;
  readonly d2: Driver;
  readonly chassis: Chassis;
  readonly director: Director | null;
  readonly isPlayer: boolean;
}

/**
 * The single place a Team is constructed. Computes the lineup's synergy from its
 * drivers + chassis and zeroes its season points, so no caller has to remember
 * to call computeSynergy itself — and adding a Team field touches only here.
 */
export function makeTeam(init: TeamInit): Team {
  return {
    name: init.name,
    d1: init.d1,
    d2: init.d2,
    chassis: init.chassis,
    director: init.director,
    synergy: computeSynergy(init.d1, init.d2, init.chassis),
    isPlayer: init.isPlayer,
    points: 0,
  };
}
